import { User } from '@auth0/auth0-spa-js';

import { UserGroup, type AuthorizedUser } from '@/types';

const userGroupsMap: Map<string, UserGroup> = new Map<string, UserGroup>([
  [UserGroup.PRIVATE.toString(), UserGroup.PRIVATE],
  [UserGroup.AGENCY.toString(), UserGroup.AGENCY],
  [UserGroup.CUSTOMER_SERVICE_AGENT.toString(), UserGroup.CUSTOMER_SERVICE_AGENT],
  [UserGroup.PERSONAL.toString(), UserGroup.PERSONAL],
]);

export function mapGroups(groups: string[]): UserGroup[] {
  return groups.reduce((mappedGroups: UserGroup[], group: string) => {
    const mappedGroup = userGroupsMap.get(group);
    return mappedGroup ? [...mappedGroups, mappedGroup] : mappedGroups;
  }, []);
}

export const mapAuth0User = (user?: User): AuthorizedUser | null => {
  if (!user) return null;

  return {
    userId: user['cognito:username'],
    auth0Id: user.sub!,
    email: user.email as string,
    name: user.name,
    picture: user.picture,
    logonId: user.preferred_username as string,
    groups: mapGroups(user['cognito:groups'] || []),
  };
};
